export const APP_TRANSLATIONS = {
  es: {
    loading: 'Rivals Base | Marvel Rivals Team ups',
    adminMode: 'Modo Admin Activo',
    adminLogin: 'Admin Login',
    emailLabel: 'Correo electrónico',
    passwordLabel: 'Contraseña',
    loginBtn: 'Ingresar',
    incorrectPwd: 'Correo o contraseña incorrectos.',
    editHero: 'Editar Héroe',
    newHero: 'Nuevo Héroe',
    charName: 'Nombre del Personaje *',
    role: 'Rol *',
    roleVanguard: 'Vanguard (Tanque)',
    roleDuelist: 'Duelist (DPS)',
    roleStrategist: 'Strategist (Soporte)',
    teamUpAbilities: 'Habilidades de Team-Up',
    addTeamUp: 'Agregar Team-Up',
    partnerName: 'Nombre del Compañero (Partner)',
    abilityName: 'Nombre de la Habilidad',
    effectDesc: 'Descripción del Efecto',
    noTeamUpsAdded: 'No hay Team-Ups agregados aún.',
    cancel: 'Cancelar',
    saveChar: 'Guardar Personaje',
    savingChar: 'Guardando...',
    chooseImage: 'Elegir imagen',
    heroImageHint: 'Se reduce a 500 px de ancho y se sube a Storage al guardar.',
    searchPlaceholder: 'Busca un héroe (ej. Loki, Thor)...',
    all: 'Todos',
    addCharBtn: 'Añadir Personaje',
    noHeroesFound: 'No se encontraron héroes.',
    image: 'Imagen',
    editInfo: 'Editar Info',
    synergiesOf: 'Sinergias de',
    partnerLabel: 'Team-Up Partner',
    noTeamUpsRegistered: 'Este héroe aún no tiene Team-Ups registrados.',
    otherHeroesTeamUps: 'También considera jugar',
    voteHintMessage: '¡Vota por tu team-up favorito!',
    voteCta: 'Votar',
    likesOne: '1 me gusta',
    adminMenuTooltip: 'Menú de admin',
    adminSignInTooltip: 'Entrar como admin',
    viewSynergiesCta: 'Ver team-ups',
    hideSynergiesCta: 'Ocultar team-ups',
    likesMany: '{count} me gusta',
    voteAddTitle: 'Votar por este team-up',
    voteRemoveTitle: 'Quitar tu voto',
    baseEffect: 'Efecto base',
    enhancedEffect: 'Efecto mejorado',
    viewSynergiesOf: 'Ver sinergias de {name}',
    teamUpWith: 'Team-up con {name}',
    goToHero: 'Ver a {name}',
    partnerSearchHint: 'También se muestran héroes que hacen team-up con "{query}"',
    heroTitleKeywords: 'Team-ups de Marvel Rivals',
    heroTitle: '¿Con quién hago team‑up?',
    cookieBannerTitle: 'Cookies',
    cookieBannerText: 'Usamos cookies para medir de forma anónima cómo se usa el sitio y así mejorarlo. No hay publicidad.',
    cookieAccept: 'Aceptar',
    cookieReject: 'Rechazar',
    cookieSettingsLink: 'Cookies',
    skipToContent: 'Saltar al contenido',
    feedbackInvite: '¿Una idea o un error? Cuéntame',
    footerCreatedBy: 'Hecho por Fer Brambi',
    preferredSourceLead: 'Ve más de Rivals Base en tus búsquedas de Google.',
    preferredSourceAction: 'Agréganos como fuente preferida',
    preferredSourceShort: 'Fuente preferida en Google',
    preferredSourceTip: 'Más noticias nuestras en tus búsquedas',
    heroSubtitle: 'Busca a tu compañero y mira con quién combina.',
    heroFacts: 'Los {count} héroes, cada team-up con su efecto base y mejorado.',
    closePanel: 'Cerrar',
    coffeeCta: '¿Te ayudó esta base de datos? Invítame un café',
    navTeamUps: 'Team ups',
    navBlog: 'Noticias',
    blogTitleKeywords: 'Marvel Rivals',
    blogPageTitle: 'Noticias y guías',
    featuredArticlesLabel: 'Imperdibles',
    latestArticlesTitle: 'Últimas noticias',
    previousArticle: 'Artículo anterior',
    nextArticle: 'Siguiente artículo',
    mostPlayedLabel: 'Los más jugados en Diamante+ esta temporada',
    mostPlayedSource: 'datos de Rivalstracker',
    pairName: '{a} y {b}',
    latestArticleLabel: 'Lo más nuevo',
    heroArticlesTitle: 'Artículos sobre {name}',
    teamUpsOf: 'Team-ups de {name}',
    alsoTeamUpWith: 'También hacen team-up con {name}',
    articleTeamUpsTitle: 'Team-ups de los héroes de este artículo',
    seeTeamUpsOf: 'Ver los team-ups de {name}',
    notFoundTitle: 'Esta página se hizo polvo.',
    notFoundDesc: 'Thanos chasqueó los dedos y se la llevó. O el enlace está mal escrito, o la cambiamos de lugar. Esto sigue en pie:',
    notFoundSnapAgain: 'Chasquear otra vez',
    notFoundTeamUps: 'Buscar team-ups',
    notFoundBlog: 'Ver noticias',
    untitledArticle: 'Artículo sin título',
    noExcerptAvailable: 'No hay extracto disponible.',
    readMore: 'Leer artículo',
    readShort: 'Leer',
    blogCloseSearch: 'Cerrar búsqueda',
    loadingEllipsis: 'Cargando...',
    metaByAuthor: 'Por',
    authorBoxAria: 'Sobre el autor: {name}',
    navAbout: 'Acerca de',
    authorArticlesHeading: 'Artículos de {name}',
    authorNoArticles: '{name} todavía no publica artículos.',
    authorPageLoading: 'Cargando el perfil…',
    authorProfileError: 'No se pudo cargar el perfil. Recarga la página para intentarlo de nuevo.',
    authorPageError: 'No se pudieron cargar los artículos. Recarga la página para intentarlo de nuevo.',
    scrollBack: 'Ver anteriores',
    scrollForward: 'Ver más',
    teamUpShare: 'Compartir',
    teamUpShareAria: 'Compartir el team-up de {a} y {b}',
    teamUpShareTitle: '{a} + {b}: team-up de Marvel Rivals',
    teamUpLinkCopied: 'Link de {a} + {b} copiado. Pégalo donde quieras.',
    metaMinRead: 'min de lectura',
    readArticleAria: 'Leer {title}',
    blogTagline: 'Parches, eventos y skins de Marvel Rivals.',
    blogFeaturedArticleAlt: 'Artículo destacado',
    blogPrevSlide: 'Artículo destacado anterior',
    blogNextSlide: 'Siguiente artículo destacado',
    blogGoToSlide: 'Ir a la diapositiva destacada {n}',
    blogPrevCategories: 'Categorías anteriores',
    blogNextCategories: 'Más categorías',
    blogFeaturedBadge: 'Imperdibles',
    articleNewBadge: 'Nuevo',
    blogNoFeaturedTitle: 'Aún no hay artículos destacados',
    blogNoFeaturedDesc: 'Marca artículos como destacados en el editor para mostrarlos en este carrusel.',
    blogCategoryNotFoundTitle: 'Categoría no encontrada',
    blogCategoryNotFoundDesc: 'Esta categoría no está disponible en el idioma seleccionado.',
    blogBrowseAllArticles: 'Ver todos los artículos',
    blogSearchPlaceholder: 'Busca noticias y guías',
    blogClearSearch: 'Borrar búsqueda',
    blogResultSingular: 'resultado',
    blogResultPlural: 'resultados',
    blogEyebrowSearch: 'Búsqueda',
    blogEyebrowCategory: 'Categoría',
    blogEyebrowLatest: 'Recientes',
    blogResultsFor: 'Resultados para "{query}"',
    blogLatestArticlesHeading: 'Últimos artículos',
    blogSearchingAllAria: 'Buscando en todos los artículos',
    blogLoadingArticlesAria: 'Cargando artículos publicados',
    blogNoSearchResults: 'Ningún artículo coincide con tu búsqueda.',
    blogNoArticlesYet: 'Aún no hay artículos publicados que coincidan con esta vista.',
    blogViewMoreArticles: 'Ver más artículos',
    blogEditorialTeamFallback: 'Equipo Editorial',
    articleLoadingArticle: 'Cargando artículo...',
    articleUnavailableEyebrow: 'Artículo no disponible',
    articleNotFoundTitle: 'No pudimos encontrar ese artículo.',
    articleNotFoundDesc: 'El artículo puede no estar publicado, no estar disponible en este idioma, o el enlace puede ser incorrecto.',
    articleBackToBlog: 'Volver a Noticias',
    articlePreviewBanner: 'Vista previa de administrador: esta página está oculta para los buscadores.',
    articleNoContent: 'Aún no hay contenido disponible.',
    articleTableHint: 'Desliza para ver más',
    imageViewerLabel: 'Visor de imágenes',
    imageViewerClose: 'Cerrar imagen',
    sliderPrevious: 'Imagen anterior',
    sliderNext: 'Imagen siguiente',
    sliderGoTo: 'Imagen {index} de {total}',
    articleKeepReadingEyebrow: 'Sigue leyendo',
    articleMoreFrom: 'Más de',
    articleReadArticle: 'Leer artículo',
    articleShare: 'Compartir',
    articleCopyLink: 'Copiar enlace',
    articleShareOnX: 'Compartir en X',
    articleShareOnFacebook: 'Compartir en Facebook',
    articleShareOnWhatsApp: 'Compartir en WhatsApp',
    articleLinkCopiedTitle: 'Enlace copiado',
    articleLinkCopiedMessage: 'Enlace del artículo copiado al portapapeles.',
    articleCopyLinkErrorMessage: 'No se pudo copiar el enlace.',
    articleShareErrorMessage: 'No se pudo abrir el panel de compartir.',
    articleLikeCta: '¿Te gustó esto?',
    articleLikedCta: 'Te gusta',
    articleLikedByCount: 'A {count} personas les gustó esto',
    articleLikeErrorMessage: "No se pudo guardar tu 'me gusta'. Inténtalo de nuevo.",
    articleLikeToastTitle: 'Me gusta',
    feedbackOpenAria: 'Enviar comentarios',
    feedbackCloseAria: 'Cerrar panel de comentarios',
    feedbackTypeGeneral: 'General',
    feedbackTypeBug: 'Error',
    feedbackTypeIdea: 'Idea',
    feedbackHeadingGeneral: '¿Qué te parece?',
    feedbackHeadingBug: '¿Algo no funciona?',
    feedbackHeadingIdea: '¿Tienes una idea?',
    feedbackPlaceholderGeneral: '¿Qué te pareció el sitio? ¿Agregarías o cambiarías algo?',
    feedbackPlaceholderBug: '¿Qué pasó? ¿Qué esperabas que sucediera en su lugar?',
    feedbackPlaceholderIdea: '¿Qué te gustaría ver agregado o cambiado?',
    feedbackEmailPlaceholder: 'Tu correo, si quieres respuesta',
    feedbackSubmit: 'Enviar comentario',
    feedbackSubmitting: 'Enviando...',
    feedbackToastTitle: 'Comentarios',
    feedbackToastSuccess: '¡Gracias por tu comentario!',
    feedbackToastError: 'No se pudo enviar tu comentario. Inténtalo de nuevo.',
    feedbackCooldownMessage: 'Ya enviaste un comentario hace poco. Espera un momento antes de enviar otro.'
  },
  en: {
    loading: 'Rivals Base | Marvel Rivals Team ups.',
    adminMode: 'Admin Mode Active',
    adminLogin: 'Admin Login',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    loginBtn: 'Login',
    incorrectPwd: 'Incorrect email or password.',
    editHero: 'Edit Hero',
    newHero: 'New Hero',
    charName: 'Character Name *',
    role: 'Role *',
    roleVanguard: 'Vanguard (Tank)',
    roleDuelist: 'Duelist (DPS)',
    roleStrategist: 'Strategist (Support)',
    teamUpAbilities: 'Team-Up Abilities',
    addTeamUp: 'Add Team-Up',
    partnerName: 'Partner Name',
    abilityName: 'Ability Name',
    effectDesc: 'Effect Description',
    noTeamUpsAdded: 'No Team-Ups added yet.',
    cancel: 'Cancel',
    saveChar: 'Save Character',
    savingChar: 'Saving...',
    chooseImage: 'Choose image',
    heroImageHint: 'Shrunk to 500 px wide and uploaded to Storage on save.',
    searchPlaceholder: 'Search a hero (e.g. Loki, Thor)...',
    all: 'All',
    addCharBtn: 'Add Character',
    noHeroesFound: 'No heroes found.',
    image: 'Image',
    editInfo: 'Edit Info',
    synergiesOf: 'Synergies of',
    partnerLabel: 'Team-Up Partner',
    noTeamUpsRegistered: 'This hero has no Team-Ups registered yet.',
    otherHeroesTeamUps: 'Also consider playing',
    voteHintMessage: 'Vote for your favorite team-up!',
    voteCta: 'Vote',
    adminMenuTooltip: 'Admin menu',
    adminSignInTooltip: 'Sign in as admin',
    viewSynergiesCta: 'See team-ups',
    hideSynergiesCta: 'Hide team-ups',
    likesOne: '1 like',
    likesMany: '{count} likes',
    voteAddTitle: 'Vote for this team-up',
    voteRemoveTitle: 'Remove your vote',
    baseEffect: 'Base effect',
    enhancedEffect: 'Enhanced effect',
    viewSynergiesOf: 'View {name} synergies',
    teamUpWith: 'Team-up with {name}',
    goToHero: 'Go to {name}',
    partnerSearchHint: 'Also showing heroes who team up with "{query}"',
    heroTitleKeywords: 'Marvel Rivals Team-Ups',
    heroTitle: 'Who should I team up with?',
    cookieBannerTitle: 'Cookies',
    cookieBannerText: 'We use cookies to measure, anonymously, how the site is used so we can improve it. No ads.',
    cookieAccept: 'Accept',
    cookieReject: 'Reject',
    cookieSettingsLink: 'Cookies',
    skipToContent: 'Skip to content',
    feedbackInvite: 'Got an idea or a bug? Tell me',
    footerCreatedBy: 'Made by Fer Brambi',
    preferredSourceLead: 'See more Rivals Base in your Google searches.',
    preferredSourceAction: 'Add us as a preferred source',
    preferredSourceShort: 'Preferred source on Google',
    preferredSourceTip: 'More of our news in your searches',
    heroSubtitle: 'Search your teammate and see who pairs best.',
    heroFacts: 'All {count} heroes, every team-up with its base and enhanced effect.',
    closePanel: 'Close',
    coffeeCta: 'Did this database help you? Buy me a coffee',
    navTeamUps: 'Team ups',
    navBlog: 'News',
    blogTitleKeywords: 'Marvel Rivals',
    blogPageTitle: 'News and guides',
    featuredArticlesLabel: 'Must reads',
    latestArticlesTitle: 'Latest news',
    previousArticle: 'Previous article',
    nextArticle: 'Next article',
    mostPlayedLabel: 'Most played in Diamond+ this season',
    mostPlayedSource: 'data from Rivalstracker',
    pairName: '{a} and {b}',
    latestArticleLabel: 'Just in',
    heroArticlesTitle: 'Articles about {name}',
    teamUpsOf: "{name}'s team-ups",
    alsoTeamUpWith: 'Also team up with {name}',
    articleTeamUpsTitle: 'Team-ups for the heroes in this article',
    seeTeamUpsOf: "See {name}'s team-ups",
    notFoundTitle: 'This page turned to dust.',
    notFoundDesc: 'Thanos snapped his fingers and it was gone. Either the link is mistyped or we moved the page. These are still standing:',
    notFoundSnapAgain: 'Snap again',
    notFoundTeamUps: 'Find team-ups',
    notFoundBlog: 'Read the news',
    untitledArticle: 'Untitled article',
    noExcerptAvailable: 'No excerpt available.',
    readMore: 'Read the article',
    readShort: 'Read',
    blogCloseSearch: 'Close search',
    loadingEllipsis: 'Loading...',
    metaByAuthor: 'By',
    authorBoxAria: 'About the author: {name}',
    navAbout: 'About',
    authorArticlesHeading: 'Articles by {name}',
    authorNoArticles: "{name} hasn't published any articles yet.",
    authorPageLoading: 'Loading the profile…',
    authorProfileError: "The profile couldn't load. Reload the page to try again.",
    authorPageError: "The articles couldn't load. Reload the page to try again.",
    scrollBack: 'Show previous',
    scrollForward: 'Show more',
    teamUpShare: 'Share',
    teamUpShareAria: 'Share the {a} and {b} team-up',
    teamUpShareTitle: '{a} + {b}: Marvel Rivals team-up',
    teamUpLinkCopied: 'Link to {a} + {b} copied. Paste it anywhere.',
    metaMinRead: 'min read',
    readArticleAria: 'Read {title}',
    blogTagline: 'Marvel Rivals patches, events and skins.',
    blogFeaturedArticleAlt: 'Featured article',
    blogPrevSlide: 'Previous featured article',
    blogNextSlide: 'Next featured article',
    blogGoToSlide: 'Go to featured slide {n}',
    blogPrevCategories: 'Previous categories',
    blogNextCategories: 'More categories',
    blogFeaturedBadge: 'Must reads',
    articleNewBadge: 'New',
    blogNoFeaturedTitle: 'No featured articles yet',
    blogNoFeaturedDesc: 'Mark articles as featured in the editor to display them in this slider.',
    blogCategoryNotFoundTitle: 'Category not found',
    blogCategoryNotFoundDesc: 'This category is unavailable in the selected language.',
    blogBrowseAllArticles: 'Browse all articles',
    blogSearchPlaceholder: 'Search news and guides',
    blogClearSearch: 'Clear search',
    blogResultSingular: 'result',
    blogResultPlural: 'results',
    blogEyebrowSearch: 'Search',
    blogEyebrowCategory: 'Category',
    blogEyebrowLatest: 'Latest',
    blogResultsFor: 'Results for "{query}"',
    blogLatestArticlesHeading: 'Latest articles',
    blogSearchingAllAria: 'Searching all articles',
    blogLoadingArticlesAria: 'Loading published articles',
    blogNoSearchResults: 'No articles match your search.',
    blogNoArticlesYet: 'No published articles match this view yet.',
    blogViewMoreArticles: 'View more articles',
    blogEditorialTeamFallback: 'Editorial Team',
    articleLoadingArticle: 'Loading article...',
    articleUnavailableEyebrow: 'Article unavailable',
    articleNotFoundTitle: 'We could not find that article.',
    articleNotFoundDesc: 'The article may be unpublished, unavailable in this language, or the link may be incorrect.',
    articleBackToBlog: 'Back to News',
    articlePreviewBanner: 'Admin preview: this page is hidden from search engines.',
    articleNoContent: 'No content available yet.',
    articleTableHint: 'Swipe to see more',
    imageViewerLabel: 'Image viewer',
    imageViewerClose: 'Close image',
    sliderPrevious: 'Previous image',
    sliderNext: 'Next image',
    sliderGoTo: 'Image {index} of {total}',
    articleKeepReadingEyebrow: 'Keep reading',
    articleMoreFrom: 'More from',
    articleReadArticle: 'Read article',
    articleShare: 'Share',
    articleCopyLink: 'Copy link',
    articleShareOnX: 'Share on X',
    articleShareOnFacebook: 'Share on Facebook',
    articleShareOnWhatsApp: 'Share on WhatsApp',
    articleLinkCopiedTitle: 'Link copied',
    articleLinkCopiedMessage: 'Article link copied to clipboard.',
    articleCopyLinkErrorMessage: 'Could not copy the link.',
    articleShareErrorMessage: 'Unable to open the share sheet.',
    articleLikeCta: 'Did you like this?',
    articleLikedCta: 'Liked',
    articleLikedByCount: '{count} people liked this',
    articleLikeErrorMessage: 'Your like could not be saved. Please try again.',
    articleLikeToastTitle: 'Like',
    feedbackOpenAria: 'Send feedback',
    feedbackCloseAria: 'Close feedback panel',
    feedbackTypeGeneral: 'General',
    feedbackTypeBug: 'Bug',
    feedbackTypeIdea: 'Idea',
    feedbackHeadingGeneral: 'What do you think?',
    feedbackHeadingBug: "Something's not working?",
    feedbackHeadingIdea: 'Got an idea?',
    feedbackPlaceholderGeneral: 'What did you think of the site? Anything you would add or change?',
    feedbackPlaceholderBug: 'What happened, and what did you expect instead?',
    feedbackPlaceholderIdea: 'What would you like to see added or changed?',
    feedbackEmailPlaceholder: 'Your email, if you want a reply',
    feedbackSubmit: 'Send feedback',
    feedbackSubmitting: 'Sending...',
    feedbackToastTitle: 'Feedback',
    feedbackToastSuccess: 'Thanks for the feedback!',
    feedbackToastError: 'Your feedback could not be sent. Please try again.',
    feedbackCooldownMessage: 'You already sent feedback recently. Please wait a moment before sending more.'
  },
  pt: {
    loading: 'Rivals Base | Marvel Rivals Team ups',
    adminMode: 'Modo Admin Ativo',
    adminLogin: 'Login Admin',
    emailLabel: 'E-mail',
    passwordLabel: 'Senha',
    loginBtn: 'Entrar',
    incorrectPwd: 'E-mail ou senha incorretos.',
    editHero: 'Editar Herói',
    newHero: 'Novo Herói',
    charName: 'Nome do Personagem *',
    role: 'Função *',
    roleVanguard: 'Vanguard (Tanque)',
    roleDuelist: 'Duelist (DPS)',
    roleStrategist: 'Strategist (Suporte)',
    teamUpAbilities: 'Habilidades de Team-Up',
    addTeamUp: 'Adicionar Team-Up',
    partnerName: 'Nome do Parceiro',
    abilityName: 'Nome da Habilidade',
    effectDesc: 'Descrição do Efeito',
    noTeamUpsAdded: 'Nenhum Team-Up adicionado ainda.',
    cancel: 'Cancelar',
    saveChar: 'Salvar Personagem',
    savingChar: 'Salvando...',
    chooseImage: 'Escolher imagem',
    heroImageHint: 'Reduzida para 500 px de largura e enviada ao Storage ao salvar.',
    searchPlaceholder: 'Busque um herói (ex. Loki, Thor)...',
    all: 'Todos',
    addCharBtn: 'Adicionar Personagem',
    noHeroesFound: 'Nenhum herói encontrado.',
    image: 'Imagem',
    editInfo: 'Editar Info',
    synergiesOf: 'Sinergias de',
    partnerLabel: 'Parceiro de Team-Up',
    noTeamUpsRegistered: 'Este herói ainda não possui Team-Ups registrados.',
    otherHeroesTeamUps: 'Também considere jogar',
    voteHintMessage: 'Vote no seu team-up favorito!',
    voteCta: 'Votar',
    likesOne: '1 curtida',
    adminMenuTooltip: 'Menu de admin',
    adminSignInTooltip: 'Entrar como admin',
    viewSynergiesCta: 'Ver team-ups',
    hideSynergiesCta: 'Ocultar team-ups',
    likesMany: '{count} curtidas',
    voteAddTitle: 'Votar neste team-up',
    voteRemoveTitle: 'Remover seu voto',
    baseEffect: 'Efeito base',
    enhancedEffect: 'Efeito aprimorado',
    viewSynergiesOf: 'Ver sinergias de {name}',
    teamUpWith: 'Team-up com {name}',
    goToHero: 'Ver {name}',
    partnerSearchHint: 'Também mostrando heróis que fazem team-up com "{query}"',
    heroTitleKeywords: 'Team-ups de Marvel Rivals',
    heroTitle: 'Com quem faço team‑up?',
    cookieBannerTitle: 'Cookies',
    cookieBannerText: 'Usamos cookies para medir de forma anônima como o site é usado e assim melhorá-lo. Sem anúncios.',
    cookieAccept: 'Aceitar',
    cookieReject: 'Recusar',
    cookieSettingsLink: 'Cookies',
    skipToContent: 'Pular para o conteúdo',
    feedbackInvite: 'Uma ideia ou um erro? Me conta',
    footerCreatedBy: 'Feito por Fer Brambi',
    preferredSourceLead: 'Veja mais do Rivals Base nas suas buscas no Google.',
    preferredSourceAction: 'Adicione-nos como fonte preferida',
    preferredSourceShort: 'Fonte preferida no Google',
    preferredSourceTip: 'Mais notícias nossas nas suas buscas',
    heroSubtitle: 'Busque seu parceiro e veja com quem ele combina.',
    heroFacts: 'Os {count} heróis, cada team-up com seu efeito base e aprimorado.',
    closePanel: 'Fechar',
    coffeeCta: 'Esta base de dados te ajudou? Me pague um café',
    navTeamUps: 'Team ups',
    navBlog: 'Notícias',
    blogTitleKeywords: 'Marvel Rivals',
    blogPageTitle: 'Notícias e guias',
    featuredArticlesLabel: 'Imperdíveis',
    latestArticlesTitle: 'Últimas notícias',
    previousArticle: 'Artigo anterior',
    nextArticle: 'Próximo artigo',
    mostPlayedLabel: 'Os mais jogados no Diamante+ nesta temporada',
    mostPlayedSource: 'dados do Rivalstracker',
    pairName: '{a} e {b}',
    latestArticleLabel: 'Mais recente',
    heroArticlesTitle: 'Artigos sobre {name}',
    teamUpsOf: 'Team-ups de {name}',
    alsoTeamUpWith: 'Também fazem team-up com {name}',
    articleTeamUpsTitle: 'Team-ups dos heróis deste artigo',
    seeTeamUpsOf: 'Ver os team-ups de {name}',
    notFoundTitle: 'Esta página virou pó.',
    notFoundDesc: 'Thanos estalou os dedos e ela sumiu. O link pode estar errado ou a página mudou de lugar. Isto continua de pé:',
    notFoundSnapAgain: 'Estalar de novo',
    notFoundTeamUps: 'Buscar team-ups',
    notFoundBlog: 'Ver notícias',
    untitledArticle: 'Artigo sem título',
    noExcerptAvailable: 'Nenhum resumo disponível.',
    readMore: 'Ler artigo',
    readShort: 'Ler',
    blogCloseSearch: 'Fechar busca',
    loadingEllipsis: 'Carregando...',
    metaByAuthor: 'Por',
    authorBoxAria: 'Sobre o autor: {name}',
    navAbout: 'Sobre',
    authorArticlesHeading: 'Artigos de {name}',
    authorNoArticles: '{name} ainda não publicou artigos.',
    authorPageLoading: 'Carregando o perfil…',
    authorProfileError: 'Não foi possível carregar o perfil. Recarregue a página para tentar de novo.',
    authorPageError: 'Não foi possível carregar os artigos. Recarregue a página para tentar de novo.',
    scrollBack: 'Ver anteriores',
    scrollForward: 'Ver mais',
    teamUpShare: 'Compartilhar',
    teamUpShareAria: 'Compartilhar o team-up de {a} e {b}',
    teamUpShareTitle: '{a} + {b}: team-up de Marvel Rivals',
    teamUpLinkCopied: 'Link de {a} + {b} copiado. Cole onde quiser.',
    metaMinRead: 'min de leitura',
    readArticleAria: 'Ler {title}',
    blogTagline: 'Patches, eventos e skins de Marvel Rivals.',
    blogFeaturedArticleAlt: 'Artigo em destaque',
    blogPrevSlide: 'Artigo em destaque anterior',
    blogNextSlide: 'Próximo artigo em destaque',
    blogGoToSlide: 'Ir para o slide em destaque {n}',
    blogPrevCategories: 'Categorias anteriores',
    blogNextCategories: 'Mais categorias',
    blogFeaturedBadge: 'Imperdíveis',
    articleNewBadge: 'Novo',
    blogNoFeaturedTitle: 'Ainda não há artigos em destaque',
    blogNoFeaturedDesc: 'Marque artigos como destaque no editor para exibi-los neste carrossel.',
    blogCategoryNotFoundTitle: 'Categoria não encontrada',
    blogCategoryNotFoundDesc: 'Esta categoria não está disponível no idioma selecionado.',
    blogBrowseAllArticles: 'Ver todos os artigos',
    blogSearchPlaceholder: 'Busque notícias e guias',
    blogClearSearch: 'Limpar busca',
    blogResultSingular: 'resultado',
    blogResultPlural: 'resultados',
    blogEyebrowSearch: 'Busca',
    blogEyebrowCategory: 'Categoria',
    blogEyebrowLatest: 'Recentes',
    blogResultsFor: 'Resultados para "{query}"',
    blogLatestArticlesHeading: 'Últimos artigos',
    blogSearchingAllAria: 'Buscando em todos os artigos',
    blogLoadingArticlesAria: 'Carregando artigos publicados',
    blogNoSearchResults: 'Nenhum artigo corresponde à sua busca.',
    blogNoArticlesYet: 'Ainda não há artigos publicados que correspondam a esta visualização.',
    blogViewMoreArticles: 'Ver mais artigos',
    blogEditorialTeamFallback: 'Equipe Editorial',
    articleLoadingArticle: 'Carregando artigo...',
    articleUnavailableEyebrow: 'Artigo indisponível',
    articleNotFoundTitle: 'Não conseguimos encontrar esse artigo.',
    articleNotFoundDesc: 'O artigo pode não estar publicado, não estar disponível neste idioma, ou o link pode estar incorreto.',
    articleBackToBlog: 'Voltar para Notícias',
    articlePreviewBanner: 'Pré-visualização de administrador: esta página está oculta dos mecanismos de busca.',
    articleNoContent: 'Ainda não há conteúdo disponível.',
    articleTableHint: 'Deslize para ver mais',
    imageViewerLabel: 'Visualizador de imagens',
    imageViewerClose: 'Fechar imagem',
    sliderPrevious: 'Imagem anterior',
    sliderNext: 'Próxima imagem',
    sliderGoTo: 'Imagem {index} de {total}',
    articleKeepReadingEyebrow: 'Continue lendo',
    articleMoreFrom: 'Mais de',
    articleReadArticle: 'Ler artigo',
    articleShare: 'Compartilhar',
    articleCopyLink: 'Copiar link',
    articleShareOnX: 'Compartilhar no X',
    articleShareOnFacebook: 'Compartilhar no Facebook',
    articleShareOnWhatsApp: 'Compartilhar no WhatsApp',
    articleLinkCopiedTitle: 'Link copiado',
    articleLinkCopiedMessage: 'Link do artigo copiado para a área de transferência.',
    articleCopyLinkErrorMessage: 'Não foi possível copiar o link.',
    articleShareErrorMessage: 'Não foi possível abrir o painel de compartilhamento.',
    articleLikeCta: 'Você gostou disso?',
    articleLikedCta: 'Curtiu',
    articleLikedByCount: '{count} pessoas curtiram isso',
    articleLikeErrorMessage: 'Não foi possível salvar sua curtida. Tente novamente.',
    articleLikeToastTitle: 'Curtir',
    feedbackOpenAria: 'Enviar feedback',
    feedbackCloseAria: 'Fechar painel de feedback',
    feedbackTypeGeneral: 'Geral',
    feedbackTypeBug: 'Erro',
    feedbackTypeIdea: 'Ideia',
    feedbackHeadingGeneral: 'O que você achou?',
    feedbackHeadingBug: 'Algo não está funcionando?',
    feedbackHeadingIdea: 'Tem uma ideia?',
    feedbackPlaceholderGeneral: 'O que você achou do site? Adicionaria ou mudaria algo?',
    feedbackPlaceholderBug: 'O que aconteceu? O que você esperava que acontecesse?',
    feedbackPlaceholderIdea: 'O que você gostaria de ver adicionado ou alterado?',
    feedbackEmailPlaceholder: 'Seu e-mail, se quiser resposta',
    feedbackSubmit: 'Enviar feedback',
    feedbackSubmitting: 'Enviando...',
    feedbackToastTitle: 'Feedback',
    feedbackToastSuccess: 'Obrigado pelo feedback!',
    feedbackToastError: 'Não foi possível enviar seu feedback. Tente novamente.',
    feedbackCooldownMessage: 'Você já enviou um feedback há pouco. Aguarde um momento antes de enviar outro.'
  }
};
